import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import injectSheet from 'react-jss';
import { Field, formValueSelector } from 'redux-form';
import Typography from '../../../Typography';
import TextInput from '../../../TextInput';
import { required, email, phone, participantDocument } from '../../../lib/validate';
import { normalizeAll, lowerCase, trim } from '../../../lib/normalize';
import CheckboxInput from '../../CheckboxInput';
import AlternateField from '../../AlternateField';

class BuyerFields extends Component {
  static propTypes = {
    intl: intlShape.isRequired,
    classes: PropTypes.object.isRequired,
    onFilled: PropTypes.func.isRequired,
    buyer: PropTypes.object.isRequired,
    foreignBuyer: PropTypes.bool.isRequired,
    event: PropTypes.object.isRequired,
  };

  state = {
    filled: false,
  };

  handleBlur = () => {
    const { onFilled, buyer } = this.props;
    const { filled } = this.state;

    if (!filled && buyer.name && buyer.email && buyer.phone && !email(buyer.email)) {
      onFilled(buyer);
      this.setState({ filled: true });
    }
  };

  validateBuyerDocument = (...args) => {
    const {
      buyer: { foreign },
    } = args[1];
    return required(...args) || (!foreign && participantDocument(...args));
  };

  render() {
    const {
      intl,
      classes,
      foreignBuyer,
      event: { registerForeignBuyerEnabled },
    } = this.props;
    return (
      <div className={classes.root} onBlur={this.handleBlur}>
        <Typography type="sectionTitle">
          <FormattedMessage id="buyerData" />
        </Typography>
        {registerForeignBuyerEnabled && (
          <Field component={CheckboxInput} name="buyer.foreign" labelId="iAmNotFromBrazil" />
        )}
        <div className={classes.row}>
          <Field
            component={TextInput}
            name="buyer.name"
            props={{ name: 'name' }}
            label={intl.formatMessage({ id: 'nameCompanyName' })}
            className={classes.input}
            validate={required}
            required
          />
          <div className={classNames(classes.input, classes.smallInput)}>
            <AlternateField visible={!foreignBuyer}>
              <Field
                component={TextInput}
                name="buyer.document"
                label={<FormattedMessage id="document" />}
                validate={this.validateBuyerDocument}
                required
              />
            </AlternateField>
            <AlternateField visible={foreignBuyer}>
              <Field
                component={TextInput}
                name="buyer.document"
                label={<FormattedMessage id="idNumber" />}
                validate={this.validateBuyerDocument}
                hint="idNumberTip"
                hintPosition="top"
                required
              />
            </AlternateField>
          </div>
        </div>
        <div className={classes.row}>
          <Field
            component={TextInput}
            name="buyer.email"
            props={{ name: 'email' }}
            label={intl.formatMessage({ id: 'email' })}
            className={classes.input}
            validate={[required, email]}
            normalize={normalizeAll([lowerCase, trim])}
            required
          />
          <Field
            component={TextInput}
            name="buyer.phone"
            placeholder="(00) 0000-0000"
            props={{ name: 'phone' }}
            label={intl.formatMessage({ id: 'phone' })}
            className={classNames(classes.input, classes.smallInput)}
            validate={[required, phone]}
            required
          />
        </div>
      </div>
    );
  }
}

const stylesheet = theme => ({
  root: {
    marginBottom: theme.spacing.medium,
  },
  row: {
    display: 'flex',
    flexWrap: 'wrap',
    '&:not(:first-child)': {
      marginTop: theme.spacing.unit,
    },
    [theme.breakpoints.up('sm')]: {
      flexWrap: 'nowrap',
      '&:not(:first-child)': {
        marginTop: theme.spacing.small,
      },
    },
  },
  input: {
    position: 'relative',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      '&:not(:first-child)': {
        marginTop: theme.spacing.unit,
      },
    },
    [theme.breakpoints.up('sm')]: {
      '&:not(:first-child)': {
        marginLeft: theme.spacing.small,
      },
    },
  },
  smallInput: {
    [theme.breakpoints.up('sm')]: {
      width: '75%',
    },
  },
});

const orderFormSelector = formValueSelector('order');
function mapStateToProps(state) {
  return {
    buyer: {
      name: orderFormSelector(state, 'buyer.name'),
      email: orderFormSelector(state, 'buyer.email'),
      phone: orderFormSelector(state, 'buyer.phone'),
    },
  };
}

export default compose(
  injectIntl,
  connect(mapStateToProps),
  injectSheet(stylesheet),
)(BuyerFields);



// WEBPACK FOOTER //
// ./src/site-render/src/RegisterExtension/OrderForm/BuyerFields/BuyerFields.js